<template>
    <div class="list-packages-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formcatalog" class="formcatalog">
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-4">
                        <select class="al-inputs required scr-input" v-model="catalog.category_laboratory_id" id="categoria">
                            <option value="">Selecciona una categoría</option>
                            <option v-for="item in catArray" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-4">
                        <input type="text" class="al-inputs required scr-input" placeholder="Nombre" v-model="catalog.name"
                               id="nombre"/>
                    </div>
                    <div class="col-12 col-sm-2">
                        <button type="button" class="formSubmit" v-on:click="guardar()">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-md-2">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">
                                {{ tituloBtn }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="catalogArray">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Categoria)="{item}">
                                {{ item.category.name }}
                            </template>
                            <template #cell(Servicio)="{item}">
                                {{ item.name }}
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {catalogLaboratoryService} from "../../Services/CatalogLaboratory.service";
import {categoryLaboratoryService} from "../../Services/CategoryLaboratory.service";
export default {
    name: "Catalog-List",
    mixins: [myMixins],
    data() {
        return {
            modificar: false,
            isBusy: false,
            fields: [
                {key: 'Categoria'},
                {key: 'Servicio'},
                {key: 'Acciones'}
            ],
            catalog: {
                name: '',
                category_laboratory_id: '',
            },
            catalogArray: [],
            catArray: [],
            tituloBtn: 'Agregar',
        }
    },
    methods: {
        updateReg(data = {}) {

            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.catalog = data
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async guardar() {
            //console.log('guardando');
            let resp = '';
            let respVal = this.valFormulariosV3('formcatalog');
            if (respVal) {
                //console.log('paso la validación');

                //actualizando
                if (this.modificar) {
                    // console.log('upgrade el paquete');
                    resp = await catalogLaboratoryService.updateOne(this.catalog.id, this.catalog);
                    this.modificar = false;
                } else {
                    //console.log('insertando el paquete');
                    resp = await catalogLaboratoryService.saveOne(this.catalog);
                }

            }

            this.setEmpty();
            this.getAlert(resp.process);
            await this.index();

        },
        async onClickDelete(id) {
            let resp = '';
            resp = await catalogLaboratoryService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async index() {
            this.isBusy = true;
            this.catalogArray = await catalogLaboratoryService.getMany();
            this.catArray = await categoryLaboratoryService.getMany();
            this.isBusy = false;
        },
        setEmpty() {
            this.catalog = {
                name: '',
                cat: '',
            }
        }

    },
    mounted() {
        this.index();
    },
}
</script>

